<template>
  <transition name="drop-down">
    <ul v-if="expanded" :class="{ active: expanded }" ref="mobileDrawer">
      <slot />
    </ul>
  </transition>
</template>
<script>
import eventBus from '@/js/util/eventBus'

export default {
  data() {
    return {
      expanded: false,
    }
  },
  methods: {
    toggleMenu(menuExpanded) {
      this.expanded = menuExpanded
    },
  },
  created() {
    eventBus.$on('toggle:menu', this.toggleMenu)
    eventBus.$on('nav:layer2:expanded', this.toggleMenu)
  },
}
</script>

<style lang="scss" scoped>
.drop-down-enter-active,
.drop-down-leave-active {
  transition: all 0.25s ease-in;
}

.drop-down-enter,
.drop-down-leave-to {
  transform: translateY(-25px);
  opacity: 0;
}
</style>
